import Slider from "../components/Slider";
import { Helmet } from "react-helmet-async";
import "./Home.scss";
const Home = ({
  slider,
  entrance,
  activeInfoIds,
  setActiveInfoIds,
  setShowInfo,
}) => {
  const photos = entrance?.photos || slider?.photos || [];
  return (
    <div className="home">
      <Helmet>
        <title>Laure Philippe</title>
      </Helmet>
      <Slider
        photos={photos}
        activeInfoIds={activeInfoIds}
        setActiveInfoIds={setActiveInfoIds}
        setShowInfo={setShowInfo}
      />
    </div>
  );
};

export default Home;
